module.exports = __webpack_public_path__ + "static/img/meeting.1e98b594.png";